// extracted by mini-css-extract-plugin
module.exports = {"gdpr":"gdpr--1TOfu","content":"content--1ys6Q","ok-btn":"ok-btn--I-Ptq","okBtn":"ok-btn--I-Ptq"};